export default __webpack_public_path__ + "static/LisaOsbourne-972db377c0df5f648ca4c4f0a70be40f.png";